import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface PostResponse {
  data: {
    posts: any[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class PostService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getPostsHighPriority(gsid: number): Observable<PostResponse> {
    const headers = new HttpHeaders({
      'cli': 'Web',
      'appversion': '1.5',
      'serviceversion': '2',
      'latitude': '0',
      'longitude': '0',
      'placeType': 'company',
      'placeId': gsid,
      'infoLevel': '2',
      'relevance': '2',
      'Authorization': `Bearer ${localStorage.getItem('gstoken') || ''}`
    });

    return this.http.get<PostResponse>(`${this.baseUrl}/posts/list`, { headers });
  }

  getPosts(gsid: number, idPost?: number): Observable<PostResponse> {
      const headers = new HttpHeaders({
        'cli': 'Web',
        'appversion': '1.5',
        'serviceversion': '2',
        'latitude': '0',
        'longitude': '0',
        'placeType': 'company',
        'placeId': gsid,
        'infoLevel': '2',
        'id_post': idPost ? idPost.toString() : '',
        'Authorization': `Bearer ${localStorage.getItem('gstoken') || ''}`
      });

      return this.http.get<PostResponse>(`${this.baseUrl}/posts/list`, { headers });
    }

  responseSurveyOptions(postId: number, surveyData?: any): Observable<PostResponse> {
  const headers = new HttpHeaders({
    'cli': 'Web',
    'appversion': '1.5',
    'serviceversion': '2',
    'latitude': '0',
    'longitude': '0',
    'Authorization': `Bearer ${localStorage.getItem('gstoken') || ''}`
  });

  return this.http.post<PostResponse>(`${this.baseUrl}/posts/info/${postId}`, surveyData, { headers }
  );
}

}